import { Logger } from './logger';
/**
 * a null or noop logger.
 * this will be use in production.
 * this will not write any logs in console or any platform
 */
export class NullLogger extends Logger {
  constructor() {
    super();
  }
}
